import React, { useState, useEffect } from "react";
import { Container, Navbar, Dropdown, Modal, Button, Badge, Table, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Icons
import { FaUnlock, FaLock, FaBell, FaMapMarkerAlt, FaBars, FaExclamationTriangle } from "react-icons/fa";
import { FaLockOpen } from "react-icons/fa6";
import { RiFileList2Fill } from "react-icons/ri";
import { SiMicrosoftexcel } from "react-icons/si";

// Logos
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png"; 
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";
import logoInvert3 from "../images/logo_proforma-removebg-preview (1).png";
import logoQlik from "../images/qlik2.png";

function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    return lockedState ? JSON.parse(lockedState) : true;
  });
  const [showMap, setShowMap] = useState(false);
  const [downloads, setDownloads] = useState([]);
  
  // Stato per le anomalie raggruppate
  const [anomalieRaggruppate, setAnomalieRaggruppate] = useState([]); 
  const [totaleAnomalie, setTotaleAnomalie] = useState(0);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showAnomalieDropdown, setShowAnomalieDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchAnomalia, setSearchAnomalia] = useState(""); 
  
  // Stato per il modale del cliente selezionato
  const [showAnomaliaModal, setShowAnomaliaModal] = useState(false);
  const [selectedClienteAnomalie, setSelectedClienteAnomalie] = useState(null);

  const handleShowMap = () => setShowMap(true);
  const handleCloseMap = () => setShowMap(false);

  const filteredDownloads = downloads.filter((item) =>
    item.ragione_sociale?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredClientiAnomalie = anomalieRaggruppate.filter((item) =>
    item.ragioneSociale?.toLowerCase().includes(searchAnomalia.toLowerCase())
  );

  const exportToExcel = () => {
    if (!downloads.length) return;
    const dataToExport = filteredDownloads.map((item) => ({
      "Ragione Sociale": item.ragione_sociale,
      "Nome File": item.nome_file,
      Data: new Date(item.quando).toLocaleDateString(),
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Downloads");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "downloads.xlsx");
  };

  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));
    let intervalId = isLocked 
      ? setInterval(() => (window.location.href = "/amotive"), 150000)
      : setInterval(() => window.location.reload(), 150000);
    return () => clearInterval(intervalId);
  }, [isLocked]);

  useEffect(() => {
    fetch("mancata_vendita_dashboard.json")
      .then((res) => res.json())
      .then((data) => { if (data?.TP?.download) setDownloads(data.TP.download); })
      .catch((err) => console.error(err));

    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => { 
        if (data?.ANOMALIE_PRELIEVO) {
          const rawAnomalie = data.ANOMALIE_PRELIEVO.flat();
          setTotaleAnomalie(rawAnomalie.length);

          // Raggruppamento per ID Cliente estraendo anche i dati generali di testata
          const mapClienti = rawAnomalie.reduce((acc, curr) => {
            const idCli = curr["ID Cliente"] || "Sconosciuto";
            
            if (!acc[idCli]) {
              acc[idCli] = {
                idCliente: idCli,
                ragioneSociale: curr["Ragione Sociale"] || "Sconosciuto",
                destinazione: curr["Destinazione"] || "-",
                dataAnomalia: curr["Data Anomalia"] || "-",
                fileSorgente: curr["File"] || "-",
                listaAnomalie: []
              };
            }
            acc[idCli].listaAnomalie.push(curr);
            return acc;
          }, {});

          setAnomalieRaggruppate(Object.values(mapClienti));
        } 
      })
      .catch((err) => console.error("Errore nel caricamento delle anomalie:", err));
  }, []);

  const handleOpenClienteDettaglio = (cliente) => {
    setSelectedClienteAnomalie(cliente);
    setShowAnomaliaModal(true);
    setShowAnomalieDropdown(false);
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="ombra-dark m-3 mb-0 mt-2 px-4 py-2 border-0 custom-red-nav"
        style={{ 
          backgroundColor: "#b81f25 !important", 
          borderRadius: "50px", 
          minHeight: "60px" 
        }}
      >
        <Container fluid className="p-0">
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img src={logo} alt="Logo" style={{ height: "30px", width: "auto" }} />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-responsive" className="border-0 shadow-none">
            <FaBars style={{ color: "white" }} />
          </Navbar.Toggle>

          <Navbar.Collapse id="navbar-responsive">
            <div className="d-flex flex-column flex-lg-row align-items-lg-center w-100 mt-3 mt-lg-0">
              
              <div className="d-flex flex-wrap align-items-center gap-3 ms-lg-4">
                <Link to="/ordini-urgenti" className="nav-link-white text-decoration-none">
                  <RiFileList2Fill className="me-1 fs-5" /> ORDINI URGENTI
                </Link>
                <div className="v-separator-white d-none d-lg-block"></div>
                <Link to="/proforma" className="nav-link-white text-decoration-none">
                  <img src={logoInvert3} alt="" className="brand-icon-white" /> PROFORMA
                </Link>
                <Link to="/sud-ricambi" className="nav-link-white text-decoration-none">
                  <img src={logoInvert} alt="" className="brand-icon-white" /> SUD RICAMBI
                </Link>
                <Link to="/amotive" className="nav-link-white text-decoration-none">
                  <img src={logoInvert2} alt="" className="brand-icon-white" /> AMOTIVE
                </Link>
              </div>

              <div className="d-flex align-items-center gap-3 ms-auto mt-3 mt-lg-0">
                
                {/* DROPDOWN ANOMALIE */}
                <Dropdown show={showAnomalieDropdown} onToggle={() => setShowAnomalieDropdown(!showAnomalieDropdown)} align="end">
                  <Dropdown.Toggle variant="transparent" className="border-0 p-0 position-relative shadow-none no-caret">
                    <div className="action-btn-glass circle-btn bg-warning-glass">
                      <FaExclamationTriangle />
                      {totaleAnomalie > 0 && (
                        <Badge bg="danger" text="white" pill className="position-absolute top-0 start-100 translate-middle shadow-sm" style={{ fontSize: '0.6rem' }}>
                          {totaleAnomalie}
                        </Badge>
                      )}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="shadow-lg border-0 p-0 mt-3 dropdown-left-shift" style={{ width: "350px", borderRadius: "15px" }}>
                    <div className="p-3 bg-light border-bottom rounded-top-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold small text-dark">ANOMALIE PER CLIENTE</span>
                        <Badge bg="dark" className="rounded-pill">{anomalieRaggruppate.length} Clienti</Badge>
                      </div>
                      <input 
                        type="text" 
                        className="form-control form-control-sm rounded-pill border-0 shadow-sm" 
                        placeholder="Cerca cliente..." 
                        value={searchAnomalia} 
                        onChange={(e) => setSearchAnomalia(e.target.value)} 
                      />
                    </div>
                    <div style={{ maxHeight: "280px", overflowY: "auto" }} className="custom-scroll">
                      {filteredClientiAnomalie.length === 0 ? (
                        <div className="p-3 text-center text-muted small">Nessun cliente trovato</div>
                      ) : (
                        filteredClientiAnomalie.map((item, index) => (
                          <div 
                            key={index} 
                            className="p-3 border-bottom hover-light transition-all px-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleOpenClienteDettaglio(item)}
                          >
                            <div className="d-flex flex-column" style={{ maxWidth: "80%" }}>
                              <span className="fw-bold text-dark truncate" style={{ fontSize: '0.78rem' }}>
                                {item.ragioneSociale}
                              </span>
                              <span className="text-muted small" style={{ fontSize: '0.65rem' }}>ID: {item.idCliente}</span>
                            </div>
                            <Badge bg="danger" className="rounded-pill p-2" style={{ fontSize: '0.7rem' }}>
                              {item.listaAnomalie.length}
                            </Badge>
                          </div>
                        ))
                      )}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>

                {/* NOTIFICHE DOWNLOAD */}
                <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)} align="end">
                  <Dropdown.Toggle variant="transparent" className="border-0 p-0 position-relative shadow-none no-caret">
                    <div className="action-btn-glass circle-btn">
                      <FaBell />
                      {downloads.length > 0 && (
                        <Badge bg="white" text="danger" pill className="position-absolute top-0 start-100 translate-middle shadow-sm" style={{ fontSize: '0.6rem' }}>
                          {downloads.length}
                        </Badge>
                      )}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="shadow-lg border-0 p-0 mt-3" style={{ width: "320px", borderRadius: "15px" }}>
                    <div className="p-3 bg-light border-bottom rounded-top-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold small text-dark">DOWNLOAD RECENTI</span>
                          <Button variant="success" size="sm" onClick={exportToExcel} className="rounded-circle p-1 d-flex align-items-center justify-content-center">
                              <SiMicrosoftexcel />
                          </Button>
                      </div>
                      <input type="text" className="form-control form-control-sm rounded-pill border-0 shadow-sm" placeholder="Filtra..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </div>
                    <div style={{ maxHeight: "250px", overflowY: "auto" }} className="custom-scroll">
                      {filteredDownloads.map((item, index) => (
                        <div key={index} className="p-2 border-bottom hover-light transition-all px-3">
                          <div className="fw-bold text-dark truncate" style={{ fontSize: '0.75rem' }}>{item.ragione_sociale}</div>
                          <div className="text-muted truncate" style={{ fontSize: '0.65rem' }}>{item.nome_file}</div>
                        </div>
                      ))}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>

                {/* QLIK */}
                <a href="https://dashboard.technoparts.it/qlik/tp.html" target="_blank" rel="noreferrer" className="action-btn-glass text-decoration-none">
                  <img src={logoQlik} alt="Qlik" style={{ width: "18px" }} />
                  <span className="ms-2 d-none d-xl-inline">QLIK</span>
                </a>

                {/* MAPPA */}
                <button onClick={handleShowMap} className="action-btn-glass">
                  <FaMapMarkerAlt />
                  <span className="ms-2 d-none d-xl-inline">MAPPA</span>
                </button>

                <div className="v-separator-white d-none d-lg-block"></div>

                {/* LOCK BUTTON */}
                <button 
                  onClick={() => setIsLocked(!isLocked)} 
                  className={`action-btn-glass circle-btn ${isLocked ? 'btn-locked-active' : ''}`}
                  title={isLocked ? "Sblocca Sessione" : "Blocca Sessione"}
                >
                  {isLocked ? <FaLock /> : <FaLockOpen />}
                </button>
              </div>
            </div>
          </Navbar.Collapse>
        </Container>

        <style>{`
          .custom-red-nav { background-color: rgb(184, 31, 37) !important; }
          .no-caret::after { display: none !important; }
          .nav-link-white { color: rgba(255,255,255,0.9) !important; font-size: 0.75rem; font-weight: 600; display: flex; align-items: center; transition: 0.2s; }
          .nav-link-white:hover { color: #fff !important; transform: translateY(-1px); }
          .brand-icon-white { width: 20px; height: 20px; margin-right: 8px; filter: brightness(0) invert(1); }
          
          .action-btn-glass {
            background: rgba(255, 255, 255, 0.15); border: 1px solid rgba(255, 255, 255, 0.1);
            padding: 6px 14px; height: 36px; border-radius: 50px; color: white !important; font-size: 0.7rem; font-weight: 700;
            display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s ease;
          }
          .action-btn-glass:hover { background: rgba(255, 255, 255, 0.25); border-color: rgba(255,255,255,0.3); transform: scale(1.05); }
          .bg-warning-glass { background: rgba(255, 193, 7, 0.2); border-color: rgba(255, 193, 7, 0.3); }
          .bg-warning-glass:hover { background: rgba(255, 193, 7, 0.35); }

          .dropdown-left-shift { left: auto !important; right: 0 !important; }
          .circle-btn { width: 36px; padding: 0; border-radius: 50%; }
          .btn-locked-active { background: #fff !important; color: #b81f25 !important; border-color: #fff; }
          .v-separator-white { width: 1px; height: 20px; background: rgba(255,255,255,0.3); margin: 0 5px; }
          
          .hover-light:hover { background-color: #f8f9fa; cursor: pointer; }
          .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
          .ombra-dark { box-shadow: 0 4px 20px rgba(0,0,0,0.3); }
          .custom-scroll::-webkit-scrollbar { width: 4px; }
          .custom-scroll::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }
          #navbar-responsive { background-color: transparent !important; flex-direction: column; align-items: flex-start; }
          
          /* Stili custom per la testata del Modale */
          .testata-box { background: #fdfdfd; border: 1px solid #dee2e6; border-radius: 8px; font-size: 0.85rem; }
          .testata-label { font-weight: bold; color: #6c757d; font-size: 0.75rem; text-uppercase: true; }
          .testata-valore { color: #212529; font-weight: 600; }
        `}</style>
      </Navbar>

      {/* MODALE MASTER-DETAIL (TESTATA + RIGHE) */}
      <Modal 
        show={showAnomaliaModal} 
        onHide={() => setShowAnomaliaModal(false)} 
        size="xl" 
        centered
        scrollable
        className="p-5"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="fs-5 fw-bold text-danger d-flex align-items-center gap-2">
            <FaExclamationTriangle /> SCHEDA ANOMALIE PRELIEVO CLIENTE
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="p-4">
          {selectedClienteAnomalie && (
            <>
              {/* 1. SEZIONE TESTATA (INFO GENERALI DEL CLIENTE) */}
              <div className="testata-box p-3 mb-4 shadow-sm">
                <h5 className="text-primary fw-bold mb-3 border-bottom pb-2 text-uppercase">
                  {selectedClienteAnomalie.ragioneSociale}
                </h5>
                <Row className="g-3">
                  <Col xs={12} sm={6} md={3}>
                    <div className="testata-label">Codice / ID Cliente</div>
                    <div className="testata-valore text-monospace">{selectedClienteAnomalie.idCliente}</div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div className="testata-label">Destinazione</div>
                    <div className="testata-valore text-truncate" title={selectedClienteAnomalie.destinazione}>
                      {selectedClienteAnomalie.destinazione}
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div className="testata-label">Data Ultima Anomalia</div>
                    <div className="testata-valore">{selectedClienteAnomalie.dataAnomalia}</div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div className="testata-label">File Sorgente JSON</div>
                    <div className="testata-valore small text-muted text-truncate" title={selectedClienteAnomalie.fileSorgente}>
                      {selectedClienteAnomalie.fileSorgente}
                    </div>
                  </Col>
                </Row>
              </div>

              {/* 2. SEZIONE RIGHE (TABELLA DI DETTAGLIO DELLE ANOMALIE) */}
              <h6 className="fw-bold mb-2 text-dark d-flex align-items-center justify-content-between">
                <span>ELENCO RIGHE IN ANOMALIA</span>
                <Badge bg="danger" pill className="px-3 py-2">
                  {selectedClienteAnomalie.listaAnomalie.length} Righe Bloccate
                </Badge>
              </h6>
              
              <div className="table-responsive border rounded">
                <Table hover className="mb-0 text-nowrap align-middle" style={{ fontSize: "0.82rem" }}>
                  <thead className="table-dark text-center">
                    <tr>
                      <th style={{ width: "8%" }}>Causale</th>
                      <th style={{ width: "8%" }}>N° Prelievo</th>
                      <th style={{ width: "8%" }}>ID Lista</th>
                      <th style={{ width: "10%" }}>Brand (Precod.)</th>
                      <th style={{ width: "12%" }}>Cod. Articolo</th>
                      <th>Descrizione Articolo</th>
                      <th style={{ width: "6%" }}>Q.tà Ord</th>
                      <th style={{ width: "6%" }}>Q.tà Sosp</th>
                      <th style={{ width: "25%" }}>Nota Errore Tecnica</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedClienteAnomalie.listaAnomalie.map((riga, idx) => (
                      <tr key={idx}>
                        <td className="text-center">
                          <Badge bg="danger" style={{ fontSize: "0.7rem" }}>{riga["Causale"]}</Badge>
                        </td>
                        <td className="text-center font-monospace">{riga["Num Prelievo"] || "-"}</td>
                        <td className="text-center font-monospace text-secondary">{riga["ID Lista Prelievo"] || "-"}</td>
                        <td className="text-center">
                          <span className="fw-bold">{riga["Precodice"]}</span> 
                          <small className="text-muted d-block">{riga["Brand"]}</small>
                        </td>
                        <td className="fw-bold text-danger font-monospace">{riga["Articolo"]}</td>
                        <td className="text-wrap" style={{ minWidth: "160px", fontSize: "0.8rem" }}>
                          {riga["Descr Articolo"]}
                        </td>
                        <td className="text-center">{parseFloat(riga["Qta"] || 0).toFixed(0)}</td>
                        <td className="text-center fw-bold text-danger bg-light-danger">
                          {parseFloat(riga["Qta Sospesa"] || 0).toFixed(0)}
                        </td>
                        <td className="text-wrap text-muted font-monospace" style={{ minWidth: "220px", fontSize: "0.78rem", lineHeight: "1.2" }}>
                          {riga["Nota"]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Modal.Body>
        
        <Modal.Footer className="bg-light d-flex justify-content-between">
          <span className="text-secondary small">
            Verificare le quantità sospese a sistema per svincolare i prelievi.
          </span>
          <Button variant="secondary" onClick={() => setShowAnomaliaModal(false)} className="rounded-pill px-4">
            Chiudi Scheda
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BasicExample;